<div class="d-flex card">
	<div class="d-flex">
		<div class="display-6 ms-1 mt-2 mb-1" *ngIf="customer">
			{{ app.references.toTitleCase(customer.firstName) }} {{ app.references.toTitleCase(customer.lastName) }}
		</div>
		<div class="display-6 ms-1 mt-2 mb-1" *ngIf="!customer"><p-skeleton></p-skeleton></div>
		<div class="ms-auto">
			<app-record-control-footer
				[hideAdd]="true"
				[hideCancel]="false"
				[hideDelete]="true"
				[hideSave]="true"
				(onCancelChange)="onClose()"
			></app-record-control-footer>
		</div>
	</div>
	<p-divider></p-divider>
	<p-tabView>
		<p-tabPanel headerStyleClass="p-tab-header">
			<ng-template pTemplate="header">
				<fa-icon [icon]="['far', 'info-circle']" size="lg" class="ms-1"></fa-icon>
				<div class="mx-2">Customer Bio</div>
			</ng-template>
			<app-customer-bio-detail *ngIf="customer"> </app-customer-bio-detail>
		</p-tabPanel>
		<p-tabPanel headerStyleClass="p-tab-header">
			<ng-template pTemplate="header">
				<fa-icon [icon]="['far', 'pencil']" size="lg" class="ms-1"></fa-icon>
				<div class="mx-2">Notes</div>
			</ng-template>
			<app-customer-note-detail *ngIf="customer"></app-customer-note-detail>
		</p-tabPanel>
		<p-tabPanel headerStyleClass="p-tab-header">
			<ng-template pTemplate="header">
				<fa-icon [icon]="['far', 'shopping-cart']" size="lg" class="ms-1"></fa-icon>
				<div class="mx-2">Online Orders</div>
			</ng-template>
			<app-customer-visit-detail *ngIf="customer" [view]="'onlineOrders'"></app-customer-visit-detail>
		</p-tabPanel>
		<p-tabPanel headerStyleClass="p-tab-header">
			<ng-template pTemplate="header">
				<fa-icon [icon]="['far', 'store']" size="lg" class="ms-1"></fa-icon>
				<div class="mx-2">In-Store</div>
			</ng-template>
			<app-customer-visit-detail *ngIf="customer" [view]="'pos'"></app-customer-visit-detail>
		</p-tabPanel>
		<p-tabPanel headerStyleClass="p-tab-header" [disabled]="!customerService.customer.value?.loyalty">
			<ng-template pTemplate="header">
				<fa-icon [icon]="['far', 'hands-heart']" size="lg" class="ms-1"></fa-icon>
				<div class="mx-2">Loyalty</div>
			</ng-template>
			<app-customer-loyalty-detail *ngIf="customer"></app-customer-loyalty-detail>
		</p-tabPanel>
		<p-tabPanel headerStyleClass="p-tab-header">
			<ng-template pTemplate="header">
				<fa-icon [icon]="['far', 'key']" size="lg" class="ms-1"></fa-icon>
				<div class="mx-2">FocusKey</div>
			</ng-template>
			<app-customer-focus-key-setup *ngIf="customer"></app-customer-focus-key-setup>
		</p-tabPanel>
		<p-tabPanel headerStyleClass="p-tab-header">
			<ng-template pTemplate="header">
				<fa-icon [icon]="['far', 'user-clock']" size="lg" class="ms-1"></fa-icon>
				<div class="mx-2">Subscriptions</div>
			</ng-template>
			<app-customer-subscription-items *ngIf="customer"></app-customer-subscription-items>
		</p-tabPanel>
	</p-tabView>
</div>
